import { Component, h, Prop, Watch } from '@stencil/core';
import { ReviewStatus } from '@ugc-components/ugc-pdp-review/interface';
import { getCustomerReviewData } from '@ugc-components/ugc-pdp-review/utils';
import state from '@ugc-store';

@Component({
  tag: 'ugc-review-pending',
  shadow: false,
})
export class UgcReviewPending {
  @Prop() productId: number;

  async componentWillLoad() {
    getCustomerReviewData(this.productId);
  }
  @Watch('productId')
  async watchProductIdHandler() {
    getCustomerReviewData(this.productId);
  }

  render() {
    const {
      isDesktop,
      userReviewData,
      reviewStaticLanguage: { IDS_LBL_EDIT_REVIEW = '' } = {},
      isShowReviewSkeleton,
    } = state;
    if (isShowReviewSkeleton) return null;
    const isPendingOrFrozen =
      userReviewData.status !== ReviewStatus.Rejected &&
      (userReviewData.status === ReviewStatus.ForReview || userReviewData.isFrozen);

    return (
      isPendingOrFrozen && (
        <div
          class={`border-1 border-gray-300 bg-white ${
            isDesktop ? 'mb-16 p-24 rounded-16 border-solid' : 'mb-8 p-16 border-bottom-solid'
          }`}
        >
          <ugc-review-pending-status />
          <ugc-review-item-pending reviewItem={userReviewData} />
          <div class="flex-row-end-center">
            <a
              class="fs-14 pointer color-blue-dark hover-link-blue-dark"
              href={`/ugc/product/${this.productId}/review`}
            >
              {IDS_LBL_EDIT_REVIEW}
            </a>
          </div>
        </div>
      )
    );
  }
}
